import { useMemo } from "react";
import useSWR from "swr";

import { fetchHasTraded } from "lib/indexer/client";

export default function useIsFirstOrder(chainId: number, p: { account?: string }) {
  const { account } = p;

  const { data: hasTraded } = useSWR(
    account ? ["isFirstOrder", chainId, account] : null,
    () => fetchHasTraded(account!).then((r) => r.hasTraded)
  );

  return useMemo(
    () => ({ isFirstOrder: hasTraded !== undefined ? !hasTraded : true }),
    [hasTraded]
  );
}
